import React, { useState } from 'react';
import { string, any, bool } from 'prop-types';
import { size } from 'lodash';
import styled, { css } from 'styled-components';
import GetOrderById from '../graphql/getOrderById';
import { Loading, Button, FlexContainer } from '../common';
import Footer from './Footer';

const Body = styled.div`
    position: relative;
    width: 21cm;
    overflow-y: hidden;
    ${({ isPrinting }) => (isPrinting === false) && css`
        height: 100vh;
        overflow-y: scroll;
        padding: 41px;
    `}
    ${({ insideOrderLabel }) => (insideOrderLabel !== true) && css`
        padding: 41px;
    `}
    margin: 0 auto;
    color: #333333;
    font-size: 9px;
    background-color: #FFFFFF;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    color-adjust: exact;
    ${({ insideOrderLabel, isPrinting }) => (isPrinting === true && insideOrderLabel === true) && css`
        width: 10cm;
    `}
    ${({ insideOrderLabel }) => (insideOrderLabel === true) && css`
        @page {
            margin: 0;
            size: 10cm 10cm;
        }
    `}
`;

const OrderPdfWrapper = ({ orderId, children, withoutFooter, insideOrderLabel, skipQuery }) => {
    const [isPrinting, setPrinting] = useState(false);

    const print = () => {
        setPrinting(true);
        setTimeout(() => {
            window.print();
            setPrinting(false);
        }, 20);
    };

    if (!skipQuery && (!orderId || size(orderId) < 1 || orderId === 'undefined')) return '';
    return (
        <FlexContainer direction='column' style={isPrinting ? { minHeight: '100vh' } : { height: '100vh', width: '100vw', justifyContent: 'flex-start' }}>
            <GetOrderById variables={{ filters: [{ field: 'idOrder', value: orderId }] }} fetchPolicy='network-only' skip={skipQuery}>
                {({ loading, data, itemsAddedByClient, ...more }) => (
                    <Loading loading={loading}>
                        {!isPrinting && <Button onClick={() => print()}>Imprimir</Button>}
                        <Body isPrinting={isPrinting} insideOrderLabel={insideOrderLabel}>
                            {children({ data, itemsAddedByClient, ...more })}
                            { !withoutFooter && <Footer isPrinting={isPrinting}>{orderId}</Footer> }
                        </Body>
                    </Loading>
                )}
            </GetOrderById>
        </FlexContainer>
    );
};

OrderPdfWrapper.propTypes = {
    orderId: string,
    children: any,
    withoutFooter: bool,
    insideOrderLabel: bool,
    skipQuery: bool
};

OrderPdfWrapper.defaultProps = {
    withoutFooter: false,
    skipQuery: false
};

export default OrderPdfWrapper;
